import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Proyects() {


  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Error | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="error" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">ERROR</h1>
          <h2 className="subtitle">No se pudo encontrar la página solicitada. Verifique si hay algún error ortográfico en la URL o <Link to="/" className="social-url dc">regrese a la página de inicio</Link>.</h2>              
        </div>
      </div>
    </div>
  </>
  );
}
